module.exports = __webpack_public_path__ + "fonts/Fortescue-Regular.17ae122143f609ddedf4e6acbb990c9d.woff";